module.exports = __webpack_public_path__ + "static/medicwhizz-188a2f92c479ade9612d307c8bf69e31.png";